export default __webpack_public_path__ + "static/media/uploader-relion-problem-2.fb7f68a0.png";